"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumeWatchingService = void 0;
var tslib_1 = require("tslib");
var firestore_1 = require("firebase/firestore");
var utils_1 = require("../../utils/utils");
var constants_1 = require("../../constants/constants");
var sdk_1 = require("../../sdk/sdk");
var ResumeWatchingService = /** @class */ (function () {
    function ResumeWatchingService(videoInfo, storageManager, profileId) {
        this.videoInfo = videoInfo;
        this.storageManager = storageManager;
        this.profileId = profileId;
    }
    ResumeWatchingService.prototype.initialize = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        try {
                            userData = (0, utils_1.getLocalStorageItemByKey)(constants_1.userDataLS);
                            if (userData && (userData === null || userData === void 0 ? void 0 : userData.userID)) {
                                this.userId = userData === null || userData === void 0 ? void 0 : userData.userID;
                            }
                            else {
                                throw new Error('User is not logged in or data is missing');
                            }
                        }
                        catch (error) {
                            console.error('Error getting user data. ', error);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.setDefaultResumeWatchingConfig()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.checkIfExistResumeWatchingItem((_a = this.videoInfo) === null || _a === void 0 ? void 0 : _a.slug)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResumeWatchingService.prototype.setDefaultResumeWatchingConfig = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var enabled;
            return tslib_1.__generator(this, function (_c) {
                this.rwConfig = (_b = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b.resumeWatching;
                if (this.rwConfig && this.videoInfo) {
                    enabled = this.rwConfig.enabled && !this.videoInfo.isLive;
                    this.setResumeWatchingIsEnabled(enabled);
                }
                else {
                    console.error('Resume watching config is undefined');
                }
                return [2 /*return*/];
            });
        });
    };
    ResumeWatchingService.prototype.checkIfExistResumeWatchingItem = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(videoId && this.userId)) return [3 /*break*/, 4];
                        if (!(this.videoInfo.parentType === constants_1.CMS_DETAILS_ITEM_TYPE.MOVIE)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.storageManager.getItem(this.userId, videoId, this.profileId)];
                    case 1:
                        _a.rwItem = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(this.videoInfo.parentType === constants_1.CMS_DETAILS_ITEM_TYPE.SERIE)) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this.storageManager.getLastWatchedEpisode(this.userId, this.videoInfo.parentSlug, this.profileId)];
                    case 3:
                        _b.rwItem = _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ResumeWatchingService.prototype, "resumeWatchingItem", {
        get: function () {
            return this.rwItem;
        },
        enumerable: false,
        configurable: true
    });
    ResumeWatchingService.prototype.setResumeWatchingIsEnabled = function (isEnabled) {
        this.isEnabled_ = isEnabled;
    };
    Object.defineProperty(ResumeWatchingService.prototype, "isEnabled", {
        get: function () {
            return this.isEnabled_;
        },
        enumerable: false,
        configurable: true
    });
    ResumeWatchingService.prototype.saveVideoProgress = function (videoDuration, currentTime) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var introEndsTime, minWatchedTime, resumeWatchingObj, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        introEndsTime = (0, utils_1.timeStringToSeconds)((_a = this.videoInfo) === null || _a === void 0 ? void 0 : _a.contextData.introEndsTime);
                        minWatchedTime = introEndsTime || this.rwConfig.minTimeWatchedSeconds;
                        if (!(this.isEnabled && videoDuration !== 0 && currentTime !== 0 && currentTime >= minWatchedTime)) return [3 /*break*/, 2];
                        resumeWatchingObj = this.createResumeWatchingObject(videoDuration, currentTime);
                        return [4 /*yield*/, this.storageManager.add(this.userId, resumeWatchingObj, this.profileId)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        console.error('Error saving video for resume watching', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ResumeWatchingService.prototype.createResumeWatchingObject = function (videoDuration, watchedDuration) {
        var _a, _b;
        var _c = this.videoInfo, slug = _c.slug, title = _c.title, parentType = _c.parentType, type = _c.type, parentSlug = _c.parentSlug;
        var _d = (_a = this.videoInfo) === null || _a === void 0 ? void 0 : _a.contextData, introEndsTime = _d.introEndsTime, creditsStartTime = _d.creditsStartTime;
        var contextData = {
            creditsStartTime: creditsStartTime || '',
            introEndsTime: introEndsTime || '',
        };
        var rwFirestoreData = {
            contextData: contextData,
            resourceDuration: videoDuration,
            parentType: parentType,
            parentSlug: parentSlug,
            resourceType: type || constants_1.EMPTY_STRING,
            slug: slug,
            timestamp: firestore_1.Timestamp.now(),
            title: title,
            watchedDuration: watchedDuration,
        };
        if (parentType === constants_1.CMS_DETAILS_ITEM_TYPE.SERIE && ((_b = this.videoInfo) === null || _b === void 0 ? void 0 : _b.parentSlug)) {
            rwFirestoreData.parentSlug = this.videoInfo.parentSlug;
        }
        return rwFirestoreData;
    };
    return ResumeWatchingService;
}());
exports.ResumeWatchingService = ResumeWatchingService;
